import script from "./UserEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditPage.vue?vue&type=script&setup=true&lang=js"

import "./UserEditPage.vue?vue&type=style&index=0&id=d2161a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2161a5c"]])

export default __exports__